import React, { useEffect, useState } from "react";
import { ApiRequest } from "../config/ApiService";

const SupportDiv = () => {
  const [supporters, setSupporters] = useState([]);

  useEffect(() => {
    getSupporters();
  }, []);

  const getSupporters = async () => {
    try {
      let req = await ApiRequest({
        url: "transactions",
        method: "get",
      });

      if (req.status == "success") {
        setSupporters(req.data);
      }
    } catch (error) {}
  };

  return (
    <div className="bg-[#052035] py-8 px-4 lg:px-8 md:p-16 lg:p-24 rounded-xl mx-4 lg:mx-auto mt-20 max-w-7xl support">
      <h1 className="font-black text-4xl lg:text-6xl mb-10 text-white text-center">
        Supporters
      </h1>

      <div className="flex justify-center items-center">
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 text-white">
          {supporters && supporters.length > 0 ? (
            supporters.map((item, index) => (
              <p key={index} className="px-1 lg:px-2 text-sm">
                {item.name}
              </p>
            ))
          ) : (
            <>
              <div className="w-[70px] h-[14px] bg-gray-500 rounded-full" />
              <div className="w-[70px] h-[14px] bg-gray-500 rounded-full" />
              <div className="w-[70px] h-[14px] bg-gray-500 rounded-full" />
              <div className="w-[70px] h-[14px] bg-gray-500 rounded-full" />
              <div className="w-[70px] h-[14px] bg-gray-500 rounded-full" />
              <div className="w-[70px] h-[14px] bg-gray-500 rounded-full" />
              <div className="w-[70px] h-[14px] bg-gray-500 rounded-full" />
              <div className="w-[70px] h-[14px] bg-gray-500 rounded-full" />
              <div className="w-[70px] h-[14px] bg-gray-500 rounded-full" />
              <div className="w-[70px] h-[14px] bg-gray-500 rounded-full" />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SupportDiv;
